import { mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('outlet', ['outletList']),

        loading() {
            return this.onLoading('save-payment');
        },

        paymentExists() {
            return this.payment !== null && this.payment.id !== undefined;
        },
    },

    created() {
        this.getOutletListIfNecessary();
    },

    methods: {
        ...mapActions('outlet', ['getOutletListIfNecessary']),

        ...mapActions('payment', [
            'getPayment',
            'updatePayment',
            'createPayment',
        ]),

        resetErrors() {
            this.errors.clear();
        },

        resetPayment() {
            this.resetErrors();

            this.$nextTick(() => {
                this.$refs.paymentName.focus();
            });
        },

        async submit() {
            let validated = await this.$validator.validateAll();

            if (!validated) {
                return;
            }

            this[this.paymentExists ? 'updatePayment' : 'createPayment'](
                this.mapPaymentValue(),
            )
                .then(res => {
                    this.successCallback();
                })
                .catch(err =>
                    this.processLaravelErrors(this.$validator, err.response),
                );
        },

        successCallback() {
            this.showToastrSuccess();

            if (this.paymentExists) {
                this.$emit('payment-updated');
            } else {
                this.$emit('payment-created');
            }

            this.resetPayment();
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/form-mixin.js